import { ActionIcon, Tooltip, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';
import cx from 'clsx';
import classes from './ColorSchemeButton.module.css';

function ColorSchemeButton() {
    const { setColorScheme } = useMantineColorScheme();
    const computedColorScheme = useComputedColorScheme('light', { getInitialValueInEffect: true });

    return (
        <Tooltip label={computedColorScheme === 'light' ? 'Notte' : 'Giorno'}>
            <ActionIcon
                onClick={() => setColorScheme(computedColorScheme === 'light' ? 'dark' : 'light')}
                variant="default"
                size={35}
                aria-label="Cambia modalità colore"
            >
                {computedColorScheme === 'dark' && <IconSun className={cx(classes.icon, classes.light)} stroke={1.5} />}
                {computedColorScheme === 'light' && <IconMoon className={cx(classes.icon, classes.light)} stroke={1.5} />}
            </ActionIcon>
        </Tooltip>
    );
}

export default ColorSchemeButton;